import { atom } from "recoil";

const loadTableIdFromSession = () => {
  try {
    const tableId =
      window.sessionStorage.getItem(
        "tableId"
      );

    if (
      tableId &&
      tableId.length <= 100 &&
      /^[A-Za-z0-9_-]+$/.test(tableId)
    ) {
      return tableId;
    }
  } catch {
    // Storage may be unavailable.
  }

  return null;
};

export const tableIdState = atom({
  key: "tableIdState",
  default: loadTableIdFromSession(),
});